/**
 * @generated SignedSource<<3dc9818d214c1103a15acc87a0aaeded>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StoreLinkedPackageModalQuery$variables = {
  packageId: string;
};
export type StoreLinkedPackageModalQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"StoreLinkedPackageModal_query">;
};
export type StoreLinkedPackageModalQuery = {
  response: StoreLinkedPackageModalQuery$data;
  variables: StoreLinkedPackageModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "packageId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "kind": "Literal",
  "name": "type",
  "value": "MEMBERSHIP"
},
v4 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }
],
v5 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "assignable",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "storeAvailability",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Club",
    "kind": "LinkedField",
    "name": "club",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "timeZone",
        "storageKey": null
      },
      (v2/*: any*/)
    ],
    "storageKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DisplayInApp",
        "kind": "LinkedField",
        "name": "displayInApp",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "availableFrom",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "availableTo",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayName",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BenefitsSummaryLine",
        "kind": "LinkedField",
        "name": "benefitsSummary",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "billingType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "startOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "activeUntilPeriod",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "activeUntilPeriodUnit",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "activeUntilPeriodType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BillingOption",
        "kind": "LinkedField",
        "name": "billingOptions",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingCharge",
            "kind": "LinkedField",
            "name": "billingCharges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "frequency",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SquareItemVariation",
                "kind": "LinkedField",
                "name": "squareVariation",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "amount",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minimumCommitmentMonths",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v6/*: any*/)
    ],
    "type": "Package",
    "abstractKey": "__isPackage"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StoreLinkedPackageModalQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "packageId",
            "variableName": "packageId"
          }
        ],
        "kind": "FragmentSpread",
        "name": "StoreLinkedPackageModal_query"
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StoreLinkedPackageModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "status",
                            "value": "ACTIVE"
                          },
                          (v3/*: any*/)
                        ],
                        "concreteType": "MemberPackageConnection",
                        "kind": "LinkedField",
                        "name": "memberPackages",
                        "plural": false,
                        "selections": (v4/*: any*/),
                        "storageKey": "memberPackages(status:\"ACTIVE\",type:\"MEMBERSHIP\")"
                      },
                      {
                        "alias": "upcomingMemberPackages",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "status",
                            "value": "UPCOMING"
                          },
                          (v3/*: any*/)
                        ],
                        "concreteType": "MemberPackageConnection",
                        "kind": "LinkedField",
                        "name": "memberPackages",
                        "plural": false,
                        "selections": (v4/*: any*/),
                        "storageKey": "memberPackages(status:\"UPCOMING\",type:\"MEMBERSHIP\")"
                      }
                    ],
                    "type": "Customer",
                    "abstractKey": null
                  },
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Club",
                    "kind": "LinkedField",
                    "name": "club",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "slug",
                        "storageKey": null
                      },
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "supportsPublic",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "logoImage",
                        "plural": false,
                        "selections": [
                          {
                            "alias": "publicId",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "renderingKey",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "package",
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "packageId"
          }
        ],
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v7/*: any*/),
            "type": "MembershipPackage",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v7/*: any*/),
            "type": "StandardPackage",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d3024f19e380bd6ef465aa6fedc61898",
    "id": null,
    "metadata": {},
    "name": "StoreLinkedPackageModalQuery",
    "operationKind": "query",
    "text": "query StoreLinkedPackageModalQuery(\n  $packageId: ID!\n) {\n  ...StoreLinkedPackageModal_query_3GEeR5\n}\n\nfragment PackageBenefitsSummary_package on Package {\n  __isPackage: __typename\n  benefitsSummary {\n    description\n  }\n}\n\nfragment StoreLinkedPackageModal_query_3GEeR5 on RootQueryType {\n  session {\n    ...StorePackageModal_session\n  }\n  package: node(id: $packageId) {\n    __typename\n    ... on MembershipPackage {\n      assignable\n      storeAvailability\n      club {\n        timeZone\n        id\n      }\n      ...packageIsAvailableForSale_package\n      ...StorePackageModal_package\n    }\n    ... on StandardPackage {\n      assignable\n      storeAvailability\n      club {\n        timeZone\n        id\n      }\n      ...packageIsAvailableForSale_package\n      ...StorePackageModal_package\n    }\n    id\n  }\n}\n\nfragment StorePackageAuth_session on Session {\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      club {\n        id\n        slug\n        name\n        supportsPublic\n        logoImage {\n          publicId: renderingKey\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment StorePackageDetailFooter_package on Package {\n  __isPackage: __typename\n  id\n  __typename\n  ...usePackageDisplayName_package\n}\n\nfragment StorePackageDetailFooter_session on Session {\n  ...useIsUserSignedIn_session\n  ...useCustomerHasActiveOrUpcomingMembership_session\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      ... on Customer {\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment StorePackageDetail_package on Package {\n  __isPackage: __typename\n  ...PackageBenefitsSummary_package\n  ...StorePackageSummary_package\n  id\n}\n\nfragment StorePackageModal_package on Package {\n  __isPackage: __typename\n  ...StorePackageDetail_package\n  ...usePackageDisplayName_package\n  ...StorePackageDetailFooter_package\n  ...StorePackageSuccess_package\n}\n\nfragment StorePackageModal_session on Session {\n  ...StorePackageDetailFooter_session\n  ...StorePackageAuth_session\n}\n\nfragment StorePackageSuccess_package on Package {\n  __isPackage: __typename\n  __typename\n}\n\nfragment StorePackageSummary_package on Package {\n  __isPackage: __typename\n  id\n  __typename\n  billingType\n  startOn\n  endOn\n  activeUntilPeriod\n  activeUntilPeriodUnit\n  activeUntilPeriodType\n  ...useGetPackagePriceMap_package\n  ...useGetMinimumCommitment_package\n}\n\nfragment packageIsAvailableForSale_package on Package {\n  __isPackage: __typename\n  displayInApp {\n    availableFrom\n    availableTo\n  }\n}\n\nfragment useCustomerHasActiveOrUpcomingMembership_session on Session {\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      ... on Customer {\n        id\n        memberPackages(status: ACTIVE, type: MEMBERSHIP) {\n          count\n        }\n        upcomingMemberPackages: memberPackages(status: UPCOMING, type: MEMBERSHIP) {\n          count\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment useGetMinimumCommitment_package on Package {\n  __isPackage: __typename\n  id\n  billingOptions {\n    minimumCommitmentMonths\n  }\n}\n\nfragment useGetPackagePriceMap_package on Package {\n  __isPackage: __typename\n  billingOptions {\n    billingCharges {\n      frequency\n      squareVariation {\n        amount\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment useIsUserSignedIn_session on Session {\n  user {\n    __typename\n    id\n  }\n}\n\nfragment usePackageDisplayName_package on Package {\n  __isPackage: __typename\n  displayInApp {\n    displayName\n  }\n  name\n}\n"
  }
};
})();

(node as any).hash = "f4de74d81178580702546d1f172140de";

export default node;
